import { useEffect, useRef } from 'react';

import { ADMIN_IMPLEMENTATION, CUTOVER } from '@/data/migration/model';
import useDialog from '@/dialogs/hooks/useDialog';
import { RIPPLING_PLATFORM_ANNOUNCEMENT_DIALOG } from '@/rippling/dialogs';
import useRipplingMigration from '@/rippling/hooks/useRipplingMigration';
import { getAuthUser } from '@/shared/auth/selectors';
import { getUpsellCookie } from '@/shared/upsell/UpsellBanner/utils/upsellCookie';
import { getUserItem, RIPPLING_PLATFORM_ANNOUNCEMENT_REMIND_LATER_SESSION_KEY } from '@/shared/util/userSessionStorage';
import { useWiwSelector } from '@/store';

export const RIPPLING_PLATFORM_ANNOUNCEMENT_COOKIE = 'rippling_platform_announcement_seen';

export const getAnnouncementCookieName = (userId: number) => `${RIPPLING_PLATFORM_ANNOUNCEMENT_COOKIE}_${userId}`;

export const shouldShowPlatformAnnouncement = ({
  migrationLoaded,
  migrationStep,
  canManage,
  hasSeen,
}: {
  migrationLoaded: boolean;
  migrationStep: string;
  canManage: boolean;
  hasSeen: boolean;
}) => migrationLoaded && canManage && !hasSeen && (migrationStep === ADMIN_IMPLEMENTATION || migrationStep === CUTOVER);

export default function RipplingPlatformAnnouncementLauncher() {
  const user = useWiwSelector(getAuthUser);
  const { migrationLoaded, migrationStep } = useRipplingMigration();
  const { open } = useDialog();
  const opened = useRef(false);

  useEffect(() => {
    const cookieName = getAnnouncementCookieName(user.id);

    if (
      opened.current ||
      !shouldShowPlatformAnnouncement({
        migrationLoaded,
        migrationStep,
        canManage: user.canManage(),
        hasSeen: Boolean(
          getUpsellCookie(cookieName) || getUserItem(RIPPLING_PLATFORM_ANNOUNCEMENT_REMIND_LATER_SESSION_KEY),
        ),
      })
    ) {
      return;
    }

    opened.current = true;
    void open(RIPPLING_PLATFORM_ANNOUNCEMENT_DIALOG, { cookieName });
  }, [migrationLoaded, migrationStep, open, user]);

  return null;
}
